'use client'

import { useState } from 'react'

// One-click follow-up: emails the founder their resume link. Manual by
// design — a human decides who gets nudged and when.
export function NudgeButton({ applicationId, lastNudgedAt }) {
  const [state, setState] = useState('idle') // idle | busy | sent | error
  const [message, setMessage] = useState(null)

  async function nudge() {
    if (state === 'busy') return
    setState('busy')
    setMessage(null)
    try {
      const res = await fetch('/api/z2h/nudge', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ applicationId }),
      })
      const data = await res.json()
      if (!res.ok || !data.ok) throw new Error(data.error || `HTTP ${res.status}`)
      setState('sent')
    } catch (err) {
      setState('error')
      setMessage(err.message)
    }
  }

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
      <button
        type="button"
        onClick={nudge}
        disabled={state === 'busy' || state === 'sent'}
        title={
          lastNudgedAt
            ? `Last nudged ${new Date(lastNudgedAt).toLocaleDateString()}`
            : 'Email their resume link'
        }
        style={{
          padding: '4px 12px',
          borderRadius: 999,
          border: '1px solid var(--theme-elevation-250)',
          background: state === 'sent' ? 'var(--theme-success-100, #e8f5e9)' : 'var(--theme-elevation-100)',
          color: 'var(--theme-text)',
          fontSize: 12,
          cursor: state === 'busy' || state === 'sent' ? 'default' : 'pointer',
          opacity: state === 'busy' ? 0.6 : 1,
        }}
      >
        {state === 'sent' ? 'Nudged ✓' : state === 'busy' ? 'Sending…' : 'Send nudge'}
      </button>
      {message && (
        <span style={{ fontSize: 11, color: 'var(--theme-error-500)' }}>{message}</span>
      )}
    </span>
  )
}
